import * as React from "react";

export interface CmAlert {
    title: string;
    description: string | React.ReactNode;
    type: CmAlertType | undefined;
}

export enum CmAlertType {
    Success = 'success',
    Warning = 'warning',
    Info = 'info',
    Error = 'error'
}